export default __webpack_public_path__ + "static/media/whole school day.89ac595d.jpg";